<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">I/V 重量容積入力</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-layout :key="group.invoiceNo" row v-for="group in invoiceGroups">
            <v-text-field disabled label="I/V No：" v-model="group.invoiceNo"></v-text-field>
            <v-text-field label="Total N/W" v-model.number="group.nw"></v-text-field>
            <v-text-field label="Total G/W" v-model.number="group.gw"></v-text-field>
            <v-text-field label="Total M/3" v-model.number="group.m3"></v-text-field>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="show = false">{{$t('app.buttons.back')}}</v-btn>
        <v-btn @click="submit">按分保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      invoiceGroups: []
    }
  },
  methods: {
    popup(invoiceNo) {
      this.invoiceGroups = []
      invoiceNo.forEach(no => {
        this.invoiceGroups.push({
          invoiceNo: no
        })
      })
      console.log(this.invoiceGroups)
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.invoiceGroups)
    }
  }
}
</script>
